export const SHOW_PAGE = 'BEAMLY/CCX/SHOW_PAGE';
export const GO_BACK = 'BEAMLY/CCX/GO_BACK';
export const GO_BACK_DONE = 'BEAMLY/CCX/GO_BACK_DONE';
export const HIDE_ALL = 'BEAMLY/CCX/HIDE_ALL';

export const showPage = slug => ({
  type: SHOW_PAGE,
  slug,
});

export const goBack = () => ({
  type: GO_BACK,
});

export const goBackDone = () => ({
  type: GO_BACK_DONE,
});

export const hideAll = () => ({
  type: HIDE_ALL,
});
